/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React, { createContext, useContext } from 'react';

interface NavigationContextType {
  openAccountMenu: () => void;
}

const NavigationContext = createContext<NavigationContextType>({
  openAccountMenu: () => {
    console.log('openAccountMenu called but not provided');
  },
});

export const useWebNavigation = (): NavigationContextType => {
  return useContext(NavigationContext);
};

export { NavigationContext };
